import {HoverPattern, makeHoverPattern} from "./utils";
import {IdentTree} from "../model";
import {Misc} from "../lexer";
import {HoverResult} from "./hover_result";

const referenceType = makeHoverPattern(
	[IdentTree, Misc.identifier] as const,
	(_chain, scope, a, b) => {
		const referent = a.referent;
		if (!referent) return null;

		return HoverResult.info(referent);
	}
);

export const TYPES_HOVERS: HoverPattern<any, any>[] = [referenceType];
